import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { deletePost } from '../../actions/userActions';
import { BubbleIcon, CommentIcon, LikeIcon, RecycleIcon } from '../../assets/icons';
import CreateNewComment from '../../components/Comments/CreateNewComment';
import MiniPlayer, { CONTROLS, POSITION } from '../../components/Stream/IvsPlayer';
import { Translate } from '../../language';
import ButtonIcon from '../../utils/components/ButtonIcon/ButtonIcon';
import ImageNameDescription from '../../utils/components/ImageNameDescription/ImageNameDescription';
import Options from '../../utils/components/Options/Options';
import localStorage from '../../utils/hooks/useLocalStorage';
import { parserNumberBase1000 } from '../../utils/parsers/number';
import MoreText from '../MoreText';
import Comment from '../Post/Comment/Comment';
import ModalReportPost from '../ReportContent/ModalReportPost';
import style from './ViewStream.module.css'
const ViewStream = ({ viewers, isLoadingPostInfo, post, comments, createReactionBubble, createReactionRecycle }) => {
    const scroolRef = useRef(null);
    const dispatch = useDispatch()
    const [isShowReport, setIsShowReport] = useState(false)
    const [isShowReportComment, setIsShowReportComment] = useState(false)
    const history = useHistory()
    const [showReplyComents, setshowReplyComents] = useState('')
    const [commentToReport, setCommentToReport] = useState(null)
    const scroolToBottom = () => {

        if (scroolRef.current) {
            const scrollHeight = scroolRef.current.scrollHeight;
            const height = scroolRef.current.clientHeight;
            const maxScrollTop = scrollHeight - height;
            scroolRef.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        }

    }
    useEffect(() => {
        scroolToBottom()
    }, []);
    useEffect(() => {
        scroolToBottom()
    }, [comments?.length]);

    if (isLoadingPostInfo || post === {})
        return (
            <div className="content-post content-not-enable-post">
                <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
        )

    const dataUser = post?.userId ? {
        _id: post.userId._id,
        name: post.userId.name,
        lastname: post.userId.lastname,
        picture: post.userId && post.userId.picture && post.userId.picture.url && post.userId.picture.url.origin
    } :
        post?.franchiseID ?
            {
                _id: post.franchiseID._id,
                name: post?.franchiseID.socialReason,
                lastname: "",
                picture: post.franchiseID && post.franchiseID.picture && post.franchiseID.picture.url && post.franchiseID.picture.url.origin
            } :
            post?.franchiseId ?
                {
                    _id: post.franchiseId._id,
                    name: post?.franchiseId.socialReason,
                    lastname: "",
                    picture: post.franchiseId && post.franchiseId.picture && post.franchiseId.picture.url && post.franchiseId.picture.url.origin
                } :
                post?.representativeID ?
                    {
                        _id: post?.representativeID._id,
                        name: post?.representativeID.userID.name,
                        lastname: post?.representativeID.userID.lastname,
                        picture: post.representativeID.userID && post.representativeID.userID.picture && post.representativeID.userID.picture.url && post.representativeID.userID.picture.url.origin
                    } :
                    post?.representativeId ?
                        {
                            _id: post?.representativeId._id,
                            name: post?.representativeId.userID.name,
                            lastname: post?.representativeId.userID.lastname,
                            picture: post.representativeId.userID && post.representativeId.userID.picture && post.representativeId.userID.picture.url && post.representativeId.userID.picture.url.origin
                        } :
                        post?.warehouseId ?
                            {
                                _id: post?.warehouseId._id,
                                name: post?.warehouseId.name,
                                lastname: "",
                                picture: post.warehouseId.profileId && post.warehouseId.profileId.picture && post.warehouseId.profileId.picture.url && post.warehouseId.profileId.picture.url.origin
                            } : {
                                _id: "",
                                name: "",
                                lastname: "",
                                lastname: "",
                                picture: "",
                            }

    return (
        <div className={style.stream_container}>
            <div className={style.stream_video_container}>
                <div className='column'>
                    <ImageNameDescription
                        firstName={dataUser.name}
                        secondName={dataUser.lastname}
                        srcImage={dataUser.picture}
                        description={`viendo ${viewers}`}
                    />
                    <Options style={{ marginLeft: "auto", position: "relative" }}
                        options={
                            (dataUser._id === localStorage().getItem('idProfile')) ? [
                                {
                                    text: Translate('delete', 'es'),
                                    onClick: () => {
                                        dispatch(deletePost(post._id, -1, history))
                                    }
                                }
                            ] : [
                                {
                                    text: Translate('report', 'es'),
                                    onClick: () => {
                                        setIsShowReport(true)
                                    }
                                },
                            ]
                        }


                    />
                    <ModalReportPost
                        reportType="content"
                        idReported={post._id}
                        displayModal={isShowReport}
                        closeModal={() => setIsShowReport(false)}
                    />
                </div>


                <MiniPlayer
                    streamUrl={post?.multimedia.url.origin}
                    controls={[CONTROLS.resize, CONTROLS.close, CONTROLS.mute]}
                    position={POSITION.topLeft}
                    transition
                />
                <div>
                    {
                        localStorage().getItem("typeProfile") != "warehouse" && (//TodoEcoCeoSocial
                            <div className="content-options-reactions-post">
                                <div className="hover-like-options-post">
                                    <div className="content-like-reactions-post">
                                        <ButtonIcon
                                            onClick={() => createReactionBubble(post._id, "post")}
                                            Icon={BubbleIcon}
                                            text={parserNumberBase1000(post?.reactions?.bubbleLikes)}
                                            type={"post-icon"}
                                        />
                                        <ButtonIcon
                                            onClick={() => createReactionRecycle(post._id, "post")}
                                            Icon={RecycleIcon}
                                            text={parserNumberBase1000(post?.reactions?.recyclingLikes)}
                                            type={"post-icon"}
                                        />
                                    </div>
                                    <ButtonIcon Icon={LikeIcon}
                                        text={parserNumberBase1000(post?.reactions?.total)}
                                        type={"post-icon"} />
                                </div>
                                <ButtonIcon
                                    Icon={CommentIcon}
                                    text={parserNumberBase1000(post?.comments)}
                                    type={"post-icon"} />

                            </div>
                        )
                    }
                </div>
            </div>
            <div className={style.stream_video_comments}>
                <ModalReportPost
                    closeModal={() => {
                        setIsShowReportComment(false)
                        // setUserToReport(null)
                    }}
                    displayModal={isShowReportComment}
                    idReported={commentToReport}

                    reportType={"content"}
            
                />
                <div ref={scroolRef} className={style.stream_video_comments_list}>
                    {comments.map((comment, index) => {

                        var dataUser = comment && (comment.userID ? comment.userID : comment.franchiseID ? comment.franchiseID : (comment.representativeID && comment.representativeID.userID) ? comment.representativeID.userID : {})
                        return (
                            <Comment
                                key={comment?._id}
                                setIsShowReport={setIsShowReportComment}
                                setCommentToReport={setCommentToReport}
                                setshowReplyComents={setshowReplyComents}
                                showReplyComents={showReplyComents}
                                createReactionBubble={() => createReactionBubble(comment._id)}
                                createReactionRecycle={() => createReactionRecycle(comment._id)}
                                reactions={comment.reactions}
                                idCommentator={dataUser._id}
                                secondName={dataUser.lastname ? dataUser.lastname : ""}
                                firstName={dataUser.name ? dataUser.name : dataUser.socialReason}
                                srcImage={dataUser.picture && dataUser.picture.url ? dataUser.picture.url.small : dataUser.picture}
                                comment={comment.text}
                                commentId={comment?._id}
                            />
                        )
                    })}
                    <div />
                </div>
                <div>
                    <CreateNewComment
                        noAdd
                        onSend={() => {
                            //scroolToBottom()
                        }}
                        postID={post?._id} />
                </div>
            </div>
        </div>
    )
};

export default ViewStream;
